export default __webpack_public_path__ + "static/media/left-green.7b88f848.svg";